import type { AppSettingsType, SettingsParamsType } from '@econtractor/types';
import { normalizeSettingsParams } from 'modules/admin';

export const getSettingsParams = (
    settings?: Pick<AppSettingsType, 'global'> | null,
): SettingsParamsType => normalizeSettingsParams(settings?.global?.params);
